import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BRAND_LOGO, BRAND_NAME, BRAND_NAME_UPPER, BRAND_YEAR } from '../brand';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const user = await login(username, password);
      if (!user) {
        setError('Erreur lors de la connexion: utilisateur non reçu');
        return;
      }
      if (user.role === 'admin' || user.role === 'super_admin') {
        navigate('/dashboard');
      } else if (user.role === 'hotesse') {
        navigate('/hostess');
      } else {
        navigate('/home');
      }
    } catch (err) {
      setError(err.message || 'Erreur lors de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--page-bg)',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Décor vague de marque */}
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '8px',
        background: 'linear-gradient(90deg, var(--brand-deep) 0%, var(--brand-deep-light) 50%, var(--brand-primary) 100%)'
      }}></div>

      <div style={{
        maxWidth: '450px',
        width: '100%',
        background: '#ffffff',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: 'var(--shadow)',
        border: '2px solid var(--border)',
        position: 'relative',
        zIndex: '1'
      }}>
        {/* Bandeau de marque */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          height: '6px',
          background: 'linear-gradient(90deg, var(--brand-deep) 0%, var(--brand-primary) 100%)',
          borderRadius: '15px 15px 0 0'
        }}></div>

        {/* Logo de la marque */}
        <div style={{ textAlign: 'center', marginBottom: '30px', marginTop: '15px' }}>
          <img
            src={BRAND_LOGO}
            alt={BRAND_NAME}
            style={{
              width: '180px',
              height: 'auto',
              marginBottom: '15px',
              filter: 'drop-shadow(0 6px 20px rgba(1, 129, 72, 0.5))'
            }}
          />
          <h3 style={{
            color: 'var(--text)',
            fontWeight: 'bold',
            margin: '10px 0 5px',
            fontSize: '28px',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            whiteSpace: 'nowrap'
          }}>
            CARTE À GRATTER
          </h3>
        </div>

        {error && (
          <div className="alert alert-danger mb-3" role="alert" style={{
            background: '#ffe5e5',
            border: '2px solid var(--brand-deep)',
            color: 'var(--brand-primary-darker)',
            borderRadius: '10px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label" style={{
              color: 'var(--text)',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}>
              Nom d'utilisateur
            </label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              style={{
                borderRadius: '10px',
                padding: '12px',
                border: '2px solid var(--brand-deep)',
                fontSize: '16px',
                background: 'var(--surface-alt)'
              }}
            />
          </div>
          <div className="mb-4">
            <label className="form-label" style={{
              color: 'var(--text)',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}>
              Mot de passe
            </label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                borderRadius: '10px',
                padding: '12px',
                border: '2px solid var(--brand-deep)',
                fontSize: '16px',
                background: 'var(--surface-alt)'
              }}
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
            style={{
              background: 'var(--brand-primary)',
              border: 'none',
              borderRadius: '15px',
              padding: '15px',
              fontSize: '18px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              color: '#ffffff',
              boxShadow: '0 8px 25px rgba(30, 43, 36, 0.12)'
            }}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Connexion...
              </>
            ) : 'Se connecter'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '25px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <small style={{ color: 'var(--brand-deep)', fontWeight: 'bold', fontSize: '12px' }}>
            © {BRAND_YEAR} {BRAND_NAME_UPPER}.
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;
